module.exports = __webpack_public_path__ + "../resources/img/ic_incomplete_number_4.6f5ed7ae.svg";